<template>
  <div class="page-bg">
    <head-nav-bar title="报表中心" :fixed="true">
      <template slot="title">
        <van-search
          v-model="searchValue"
          shape="round"
          @search="onSearchBefore"
          placeholder="请输入搜索关键词"
        />
      </template>
      <template slot="right">
        <van-dropdown-menu v-model="categoryId">
          <van-dropdown-item :title="categoryName" ref="dropDownMenu">
            <van-cell
              v-for="(item, index) in categoryList"
              :title="item.Name"
              :key="item.Id"
              @click="onCategoryChange({ row: item, rowIndex: index })"
            >
              <template #right-icon v-if="categoryIndex == index">
                <van-icon name="checked" />
              </template>
            </van-cell>
          </van-dropdown-item>
        </van-dropdown-menu>
      </template>
    </head-nav-bar>
    <div class="report-box">
      <div class="order-list">
        <DataList
          ref="dataList"
          class="dataList"
          :api="getList"
          :params="params"
          dataField="Data.Datas"
          totalField="Data.Total"
        >
          <template v-slot:item="item">
            <div class="item">
              <div class="left" @click="onDetail(item)">
                <div class="icon">
                  <van-icon name="balance-list" color="#1989fa" />
                </div>
                <div class="center">
                  <p class="title">
                    <span>{{ item.Name }}</span>
                  </p>
                  <p>{{ item.ReportGroupName }}（{{ item.Code }}）</p>
                </div>
              </div>
              <div class="right" @click.stop="onFavor(item, index)">
                <van-icon
                  name="star"
                  color="#ffd21e"
                  v-if="item.IsFavor || categoryId == 'isMyFavor'"
                />
                <van-icon name="star-o" v-else />
              </div>
            </div>
          </template>
        </DataList>
      </div>
    </div>
  </div>
</template>
<script>
import { Cell, Icon, Tag, DropdownMenu, DropdownItem, Search } from "vant";
import DataList from "@/components/DataList";
import { mapState } from "vuex";
import reportApi from "@/api/report";
import $config from "@/config/baseConfig";
const otherCategoryList = [{ Name: "我的收藏", Id: "isMyFavor" }];

export default {
  name: "reportList",
  components: {
    [Search.name]: Search,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [Tag.name]: Tag,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    DataList,
  },
  computed: {
    ...mapState({
      user: state => state.user.info,
    }),
  },
  props: {
    actionApi: {
      type: Object,
      default: () => {
        return {
          favorList: reportApi.FavorGetList,
          setFavor: reportApi.FavorAdd,
          cancelFavor: reportApi.FavorDelete,
          getGroups: reportApi.GetReportGroupsAsync,
          getReports: reportApi.GetPageList,
        };
      },
    },
  },
  data() {
    return {
      getList: this.actionApi.favorList,
      categoryName: otherCategoryList[0].Name,
      categoryId: otherCategoryList[0].Id,
      categoryIndex: 0,
      categoryList: [],
      data: [],
      searchValue: "",
      params: {},
    };
  },
  mounted() {
    this.onGetGroupList();
  },
  methods: {
    onDetail(item) {
      // eslint-disable-next-line no-undef
      const serverUrl = $config.http.serverUrl;
      let url =
        this.user.ReportUrl +
        "/show?reportid=" +
        item.Code +
        "&url=" +
        serverUrl.substring(serverUrl.lastIndexOf("//") + 2, serverUrl.length) +
        "&Token=" +
        this.user.Token;
      this.$router.push({
        name: "ReportIndex",
        query: {
          reportUrl: url,
          title: item.Name,
        },
      });
    },
    onFavor(item) {
      let api = "",
        param = {};
      if (item.IsFavor || this.categoryId == "isMyFavor") {
        api = this.actionApi.cancelFavor;
        param = { Id: item.Id };
      } else {
        api = this.actionApi.setFavor;
        param = { ReportId: item.Id };
      }
      api(param).then(() => {
        this.$refs.dataList.reload();
      });
    },
    onSearchBefore(e) {
      this.params = {
        Name: e,
        ReportGroupId: "",
      };
    },
    onCategoryChange({ row, rowIndex }) {
      if (row.Id == "isMyFavor") {
        this.getList = this.actionApi.favorList;
        this.params = {};
      } else {
        this.getList = this.actionApi.getReports;
        this.params = {
          Name: "",
          ReportGroupId: row.Id,
        };
      }
      this.categoryName = row.Name;
      this.categoryId = row.Id;
      this.categoryIndex = rowIndex;
      this.searchValue = "";
      this.$refs.dropDownMenu.toggle(false);
    },
    onGetGroupList() {
      let that = this;
      this.actionApi
        .getGroups({ From: "reportcenter" })
        .then(res => {
          that.categoryList = otherCategoryList.concat(res.Data);
          this.$nextTick(() => {
            that.$refs.dataList.reload();
          });
        })
        .catch(() => {});
    },
  },
};
</script>
<style lang="less" scoped>
/deep/.van-dropdown-menu__bar {
  background: transparent;
  box-shadow: none;
  .van-dropdown-menu__title {
    font-size: 13px;
  }
}

.navbar .van-icon-checked {
  position: absolute;
  right: 15px;
  top: 13px;
  color: green;
  font-size: 20px;
}
.report-box {
  background: #f6f6f6;
  height: calc(100vh - 50px);
  overflow: auto;
  padding-bottom: 40px;
  margin-top: 45px;
  .order-list {
    padding: 5px;
    .item {
      padding: 8px;
      background: white;
      padding: 8px;
      min-height: 50px;
      font-size: 14px;
      border-radius: 3px;
      position: relative;
      box-shadow: 1px 1px 3px #e5e5e5;
      display: flex;
      .left {
        display: flex;
        flex: 1;
        .icon {
          display: flex;
          align-items: center;
          padding: 4px 5px 2px;
          font-size: 30px;
        }
        p {
          font-size: 12px;
        }
        .title {
          font-size: 16px;
          padding-bottom: 2px;
          span {
            margin-right: 4px;
          }
        }
      }
      .right {
        padding: 0 5px;
        font-size: 26px;
        display: flex;
        align-items: center;
      }
    }
  }
}
/deep/.van-search {
  padding: 5px 0;
  width: 90%;
}
</style>
